import React from 'react';
import SelectField from 'components/pure/utils/form/SelectField';

const toOption = model => ({label: model.name, value: model.id});

export default props => (
  <SelectField
    placeholder="Select a team"
    options={props.teams.map(toOption)}
    hideResetButton={true}
    tether={true}
    {...props}
  />
);
